import React from "react";
import TwoCol from "../../containers/twoCol";
import FlexText from "../../flexText";
import VideoHead from "../../video/VideoHead";

const VideoBlock = ({ row, linkColor, ImageBG, attributes, token }) => (
  <TwoCol className={linkColor} styles={{ paddingTop: "49px", ...ImageBG }}>
    {window.innerWidth < 900 ? (
      <div style={{ width: "100vw", marginLeft: "-24px" }}>
        <VideoHead
          media={row.field_link_2}
          id={row.item_id}
          width="560"
          height="315"
          controls="controls"
          token={token}
        />
      </div>
    ) : (
      <VideoHead
        media={row.field_link_2}
        id={row.item_id}
        width="560"
        height="315"
        controls="controls"
        token={token}
      />
    )}

    {typeof row.field_text_1 !== "undefined" ? (
      <FlexText
        color={attributes.field_heading_color_font[0].field_color_1}
        tag="h3"
        max="20.8"
        min="17"
        styles={{
          textAlign: "left",
          textTransform: "none",
          fontFamily: "Oswald",
          marginTop: "-5px",
        }}
      >
        {row.field_text_1}
      </FlexText>
    ) : null}
    {typeof row.field_longtext_1 !== "undefined" ? (
      <FlexText
        tag="p"
        color={attributes.field_text_color_font[0].field_color_1}
        max="16"
        min="14"
        styles={{
          //textAlign:"center",
          fontFamily: "Roboto",
          textTransform: "none",

          margin: "0 10%",
        }}
      >
        {row.field_longtext_1}
      </FlexText>
    ) : null}
  </TwoCol>
);

export default VideoBlock;
